var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-visible"},[_c('div',{staticClass:"h-1 w-full bg-neutral-200 dark:bg-neutral-600"},[_c('div',{ref:"ProgressBar",staticClass:"h-1 bg-primary progress-bar"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }